/** สี Tag รอคิว Speed — เทียบ ShippingLabelStatusCell (order) */
export const PARCEL_PENDING_QUEUE_TAG_COLOR = "purple";

/** ข้อความ 2 บรรทัด — เทียบ order PENDING/PROCESSING */
export const PARCEL_PENDING_QUEUE_LINE1 = "⏳ กำลังเชื่อมต่อกับระบบขนส่ง";
export const PARCEL_PENDING_QUEUE_LINE2 = "เพื่อขอหมายเลขพัสดุ";

/** ข้อความ UI ตาม speed_queue_status — ตรงแผน factory-parcel-async-queue Phase F */
export const PARCEL_SPEED_QUEUE_LABEL_TH: Record<string, string> = {
  PENDING: PARCEL_PENDING_QUEUE_LINE1,
  PROCESSING: PARCEL_PENDING_QUEUE_LINE1,
  UNKNOWN: "กำลังตรวจสอบกับบริษัทขนส่ง กรุณารอสักครู่",
  FAILED: "ไม่สามารถเชื่อมต่อบริษัทขนส่งได้ โปรดทำรายการใหม่อีกครั้ง",
};

export type ParcelTableStatusDisplay = {
  label: string;
  tagColor: string;
  /** แสดง Tag ม่วง 2 บรรทัด (สร้างใหม่ / retry → PENDING|PROCESSING) */
  pendingQueue?: boolean;
};

/** ข้อความ + สี Tag สำหรับคอลัมน์สถานะ (รวม pending_ship + คิว Speed) */
export const resolveParcelTableStatusDisplay = (
  record: {
    status?: string | null;
    speed_queue_status?: string | null;
    tracking_number?: string | null;
  },
  shippingStatusLabels: Record<string, string>,
  shippingStatusColors: Record<string, string>
): ParcelTableStatusDisplay => {
  const hasTracking = !!record.tracking_number?.trim();
  const queue = String(record.speed_queue_status || "").toUpperCase();

  if (record.status === "pending_ship" || (!hasTracking && queue && queue !== "SUCCESS")) {
    if (queue === "FAILED") {
      return { label: PARCEL_SPEED_QUEUE_LABEL_TH.FAILED, tagColor: "error" };
    }
    if (queue === "UNKNOWN") {
      return { label: PARCEL_SPEED_QUEUE_LABEL_TH.UNKNOWN, tagColor: "warning" };
    }
    return {
      label: "",
      tagColor: PARCEL_PENDING_QUEUE_TAG_COLOR,
      pendingQueue: true,
    };
  }

  const s = record.status?.trim() || "";
  return {
    label: shippingStatusLabels[s] ?? (s || "-"),
    tagColor: shippingStatusColors[s] || "default",
  };
};

export const parcelListNeedsQueuePoll = (
  items: { speed_queue_status?: string | null }[]
): boolean =>
  items.some((r) =>
    ["PENDING", "PROCESSING", "UNKNOWN"].includes(String(r.speed_queue_status || ""))
  );
